import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ArtikelGroupFilterSettingsServiceConfig = {
  name: "ArtikelGroupFilterSettings",
  annotations: []
} as ServiceConfig;